var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider-container"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"image-container"},[_c('v-img',{attrs:{"src":_vm.imgSrc,"width":"60px"}})],1),_c('div',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }